import {
  Injectable,
  Optional,
} from '@angular/core';
import {
  LocalizationService,
} from '@o3r/localization';
import {
  FactsService,
  RulesEngineRunnerService,
} from '@o3r/rules-engine';
import {
  AppPreferencesFacts,
} from './app-preferences.facts';
import {
  retrieveLanguage,
} from './fact-factories';

@Injectable()
export class AppPreferencesFactsService extends FactsService<AppPreferencesFacts> {
  public facts = {
    language: retrieveLanguage()(this.localizationService)
  };

  constructor(rulesEngine: RulesEngineRunnerService, @Optional() private readonly localizationService: LocalizationService) {
    super(rulesEngine);
  }
}
